import { z } from 'zod'

export const LessonContentSchema = z.object({
  videoUrl: z.string().url().optional(),
  textContent: z.string().optional(),
  quizData: z.any().optional(),
  assignmentData: z.any().optional()
})

export const LessonSchema = z.object({
  id: z.string(),
  courseId: z.string(),
  title: z.string().min(1, 'Título é obrigatório'),
  description: z.string(),
  duration: z.number().min(1, 'Duração deve ser maior que 0'),
  type: z.enum(['video', 'text', 'quiz', 'assignment']),
  content: LessonContentSchema,
  order: z.number().min(1),
  isCompleted: z.boolean().optional(),
  completedAt: z.date().optional().nullable(),
  progress: z.number().min(0).max(100).optional()
})

export const InstructorSchema = z.object({
  id: z.string(),
  name: z.string().min(1, 'Nome é obrigatório'),
  avatar: z.string().url().optional()
})

export const CourseSchema = z.object({
  id: z.string(),
  title: z.string().min(1, 'Título é obrigatório'),
  description: z.string().min(10, 'Descrição deve ter pelo menos 10 caracteres'),
  thumbnail: z.string().url().optional(),
  duration: z.number().min(1, 'Duração deve ser maior que 0'),
    category: z.string().min(1, 'Categoria é obrigatória'),
  instructor: InstructorSchema,
  lessons: z.array(LessonSchema),
  progress: z.number().min(0).max(100).optional(),
  enrolledAt: z.date().optional(),
  completedAt: z.date().optional().nullable(),
  rating: z.number().min(1).max(5).optional(),
  totalStudents: z.number().min(0),
  tags: z.array(z.string()),
  status: z.enum(['draft', 'published', 'archived']),
  createdAt: z.date(),
  updatedAt: z.date()
})

export const CourseProgressSchema = z.object({
  courseId: z.string(),
  userId: z.string(),
  progress: z.number().min(0).max(100),
  completedLessons: z.array(z.string()),
  currentLesson: z.string().optional(),
  timeSpent: z.number().min(0),
  lastAccessedAt: z.date()
})

// Form schemas for creating/editing
export const CreateCourseSchema = z.object({
  title: z.string().min(1, 'Título é obrigatório'),
  description: z.string().min(10, 'Descrição deve ter pelo menos 10 caracteres'),
  thumbnail: z.string().url().optional(),
    category: z.string().min(1, 'Categoria é obrigatória'),
  tags: z.array(z.string()).min(1, 'Pelo menos uma tag é obrigatória')
})

export const CreateLessonSchema = z.object({
  title: z.string().min(1, 'Título é obrigatório'),
  description: z.string(),
  duration: z.number().min(1, 'Duração deve ser maior que 0'),
  type: z.enum(['video', 'text', 'quiz', 'assignment']),
  content: LessonContentSchema,
  order: z.number().min(1)
})

// Type exports
export type Course = z.infer<typeof CourseSchema>
export type Lesson = z.infer<typeof LessonSchema>
export type LessonContent = z.infer<typeof LessonContentSchema>
export type Instructor = z.infer<typeof InstructorSchema>
export type CourseProgress = z.infer<typeof CourseProgressSchema>
export type CreateCourseData = z.infer<typeof CreateCourseSchema>
export type CreateLessonData = z.infer<typeof CreateLessonSchema>